import i18n from "i18next";

import type { State } from "api/services/appointment/schemas/shared";

export function translateAppointmentState(state: State): string {
  const keyMap: Record<State, string> = {
    canceled: i18n.t("booking.event_details.canceled"),
    completed: i18n.t("booking.event_details.completed"),
    confirmed: i18n.t("booking.event_details.confirmed"),
    expired: i18n.t("booking.event_details.expired"),
    no_show: i18n.t("booking.event_details.no_show"),
    pending: i18n.t("booking.event_details.pending"),
    rescheduled: i18n.t("booking.event_details.rescheduled"),
  };

  return keyMap[state] || "";
}
